import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import SideDrawer from "../header/SideDrawer";
import Header from "../header/Header";
import { Box, CssBaseline } from "@material-ui/core";

export function HomeAdmin() {
  const location = useLocation();
  const narrow = useMediaQuery("(max-width:899.95px)");
  const cartera = location.pathname.includes("gestion-cartera");
  const temporaryMenu = cartera && narrow;
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header compact={temporaryMenu} onMenu={temporaryMenu ? () => setMenuOpen(true) : undefined} />
      <SideDrawer temporary={temporaryMenu} open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Outlet />
    </Box>
  );
}